function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "lg1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#814aa0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4701,
  stopColor: "#5b3374"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#192a7d"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 210.827,
  x2: 546.901,
  xlinkHref: "#lg1",
  y1: 326.42,
  y2: 326.42
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 98,
  x2: 496.015,
  xlinkHref: "#lg1",
  y1: 358.985,
  y2: 358.985
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 98,
  x2: 496.015,
  xlinkHref: "#lg1",
  y1: 326.42,
  y2: 326.42
});

var _ref6 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 22,
  x2: 536.048,
  y1: 255,
  y2: 255
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff9df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.593,
  stopColor: "#ffe177"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#feb237"
}));

var _ref7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "lg2"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffe177"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#feb237"
}));

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 79,
  x2: 263.7,
  xlinkHref: "#lg2",
  y1: 122.976,
  y2: 122.976
});

var _ref9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: 101.804,
  x2: 551.859,
  xlinkHref: "#lg2",
  y1: 409.625,
  y2: 409.625
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 101.804,
  x2: 551.859,
  xlinkHref: "#lg2",
  y1: 56.288,
  y2: 56.288
});

var _ref11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: 101.804,
  x2: 551.859,
  xlinkHref: "#lg2",
  y1: 56.379,
  y2: 56.379
});

var _ref12 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_9_",
  gradientUnits: "userSpaceOnUse",
  x1: 101.804,
  x2: 551.859,
  xlinkHref: "#lg2",
  y1: 453.666,
  y2: 453.666
});

var _ref13 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_10_",
  gradientUnits: "userSpaceOnUse",
  x1: 101.804,
  x2: 551.859,
  xlinkHref: "#lg2",
  y1: 255,
  y2: 255
});

var _ref14 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_11_",
  gradientUnits: "userSpaceOnUse",
  x1: -3.699,
  x2: 222.778,
  xlinkHref: "#lg1",
  y1: 96.129,
  y2: 96.129
});

var _ref15 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_12_",
  gradientUnits: "userSpaceOnUse",
  x1: -38,
  x2: 183.475,
  xlinkHref: "#lg1",
  y1: 96.129,
  y2: 96.129
});

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m457.874 313.878c-2.333 0-4.626.169-6.879.466-5.912-44.942-44.362-79.634-90.918-79.634-38.88 0-72.107 24.196-85.45 58.35-32.572 2.214-58.312 29.319-58.312 62.453 0 34.582 28.034 62.616 62.616 62.616h178.942c28.788 0 52.126-23.338 52.126-52.126.001-28.787-23.337-52.125-52.125-52.125z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m250.312 299.841c-20.183 10.39-33.997 31.408-33.997 55.673 0 34.582 28.034 62.616 62.616 62.616h127.218v-1c-73.983 0-136.383-49.56-155.837-117.289z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m457.874 313.878c-2.333 0-4.626.169-6.879.466-5.912-44.942-44.362-79.634-90.918-79.634-6.878 0-13.574.771-20.02 2.207 34.929 7.772 62.357 35.45 69.739 70.523.797 3.787 4.117 6.443 7.987 6.438h.07c28.788 0 52.126 23.338 52.126 52.126s-23.338 52.126-52.126 52.126h39.162c28.585 0 52.499-22.654 52.976-51.235.489-29.196-23.032-53.017-52.117-53.017z",
  fill: "url(#SVGID_3_)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m381.139 417.13c-89.885 0-162.686-73.145-162.126-163.16.556-89.492 72.633-161.1 162.127-161.1 26.612 0 51.726 6.412 73.88 17.776 16.494 8.46 32.579-12.109 20.198-25.905-46.461-51.773-113.791-84.433-188.761-84.739-140.897-.574-256.062 114.101-256.062 254.999 0 140.832 114.168 254.999 255 254.999 75.345 0 143.053-32.68 189.729-84.637 12.396-13.798-3.511-34.534-20.009-26.058-22.178 11.394-47.325 17.825-73.976 17.825z",
  fill: "url(#SVGID_4_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.197 182.942h120.587c19.4 0 35.127-15.727 35.127-35.127s-15.727-35.127-35.127-35.127c-1.573 0-3.118.114-4.635.314-3.048-23.169-18.935-42.282-40.277-49.991-36.021 31.475-63.153 72.883-77.06 119.896.461.015.92.035 1.385.035z",
  fill: "url(#SVGID_5_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 165.012,
  cy: 409.625,
  fill: "url(#SVGID_6_)",
  r: 42.575
}), /*#__PURE__*/React.createElement("circle", {
  cx: 268.053,
  cy: 56.288,
  fill: "url(#SVGID_7_)",
  r: 29.707
}), /*#__PURE__*/React.createElement("path", {
  d: "m329.104 38.677c1.251 10.413 9.682 18.752 20.107 19.903 7.349.812 14.097-1.861 18.8-6.573 7.828-7.843 20.344-8.49 29.343-2.024 11.308 8.126 25.232 19.731 37.844 34.759 5.005 5.963 5.366 12.777 2.602 18.308 5.985 2.233 11.802 4.808 17.428 7.704 16.558 8.524 32.514-12.041 20.083-25.908-46.464-51.835-113.834-84.538-188.854-84.844-7.09-.029-14.11.248-21.058.791 25.507 1.982 49.957 7.721 72.807 16.655-6.321 4.685-10.145 12.548-9.102 21.229z",
  fill: "url(#SVGID_8_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m455.115 399.304c-5.599 2.877-11.389 5.435-17.344 7.655 2.741 5.569 2.548 12.597-2.667 18.403-42.514 47.323-102.476 78.643-169.763 83.855 6.617.515 13.304.782 20.053.782 75.345 0 143.053-32.68 189.729-84.637 12.397-13.797-3.509-34.534-20.008-26.058z",
  fill: "url(#SVGID_9_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m361.14 415.901c-80.437-9.896-142.645-78.698-142.128-161.931.514-82.697 62.101-150.116 142.067-159.879-6.541-.803-13.202-1.221-19.96-1.221-88.375 0-159.758 69.83-162.064 157.754-.022 0-.044-.002-.066-.002-16.991 0-30.651 14.265-29.656 31.472.858 14.841 12.88 26.927 27.716 27.88.103.007.206.013.309.018 6.673.361 12.673 4.282 15.371 10.396 25.14 56.972 82.117 96.741 148.391 96.741 6.779.001 13.46-.42 20.02-1.228z",
  fill: "url(#SVGID_10_)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m162.784 87.677c-1.573 0-3.118.114-4.635.314-3.984-30.286-29.895-53.664-61.268-53.664-26.201 0-48.592 16.305-57.584 39.322-21.951 1.491-39.297 19.757-39.297 42.085 0 23.304 18.892 42.197 42.197 42.197h120.587c19.4 0 35.127-15.727 35.127-35.127 0-19.401-15.727-35.127-35.127-35.127z",
  fill: "url(#SVGID_11_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m162.784 87.677c-1.573 0-3.118.114-4.635.314-3.984-30.286-29.895-53.664-61.268-53.664-7.003 0-13.729 1.175-20.005 3.321 20.408 6.984 36.003 24.343 40.48 45.788.527 2.522 2.785 4.244 5.362 4.24h.047c19.4 0 35.127 15.727 35.127 35.127s-15.727 35.127-35.127 35.127h39.326c19.697 0 36.191-16.119 35.814-35.812-.366-19.083-15.95-34.441-35.121-34.441z",
  fill: "url(#SVGID_12_)"
}));

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.306cc614.svg";
export { ForwardRef as ReactComponent };